export const C = {
  evergreen: "#112215",
  tea: "#CCF5AC",
  copper: "#CD533B",
  peach: "#FED7C3",
  linen: "#F4F1E7",
  white: "#FFFFFF",
  muted: "#5E6B62",
  faint: "#9AA39C",
  line: "#E7E3D8",
};

export const SERIF = "'Season Mix', Georgia, serif";
export const SANS = "'Inter', sans-serif";
export const PAGE_W = 794;
export const PAGE_H = 1123;